const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "producers.today";
const SOURCE_KEY = `${BRAND_NAME.replace(/[^a-z0-9]/gi, "_")}_lead_source`;

const SOURCE_MAP = {
  fb: "Facebook",
  facebook: "Facebook",
  ig: "Instagram",
  instagram: "Instagram",
  li: "LinkedIn",
  linkedin: "LinkedIn",
  yt: "YouTube",
  youtube: "YouTube",
  tw: "Twitter/X",
  twitter: "Twitter/X",
  x: "Twitter/X",
  tt: "TikTok",
  tiktok: "TikTok",
  pin: "Pinterest",
  pinterest: "Pinterest",
};

const formatSourceName = (src) => {
  if (!src) return "";
  const s = src.toLowerCase().trim();
  if (SOURCE_MAP[s]) {
    return SOURCE_MAP[s];
  }
  // If it's a custom source, capitalize the first letter
  return src.charAt(0).toUpperCase() + src.slice(1);
};

export const initLeadTracker = () => {
  // If we already captured a source in this session, keep it
  if (sessionStorage.getItem(SOURCE_KEY)) {
    return;
  }

  // 1. Try URL parameters first
  const params = new URLSearchParams(window.location.search);
  const rawSource = params.get("ref") || params.get("utm_source") || params.get("source") || params.get("src");

  if (rawSource) {
    const formatted = formatSourceName(rawSource);
    sessionStorage.setItem(SOURCE_KEY, formatted);
    return;
  }

  // 2. Try document.referrer as fallback
  const referrer = document.referrer;
  if (referrer) {
    try {
      const url = new URL(referrer);
      const host = url.hostname.toLowerCase();
      
      let detectedSource = null;
      if (host.includes("facebook.com") || host.includes("fb.com")) {
        detectedSource = "Facebook";
      } else if (host.includes("instagram.com")) {
        detectedSource = "Instagram";
      } else if (host.includes("linkedin.com")) {
        detectedSource = "LinkedIn";
      } else if (host.includes("youtube.com") || host.includes("youtu.be")) {
        detectedSource = "YouTube";
      } else if (host.includes("twitter.com") || host.includes("t.co") || host.includes("x.com")) {
        detectedSource = "Twitter/X";
      } else if (host.includes("tiktok.com")) {
        detectedSource = "TikTok";
      } else if (host.includes("google.com")) {
        detectedSource = "Google Search";
      } else if (!host.includes(window.location.hostname)) {
        // Record other external referrers
        detectedSource = url.hostname;
      }

      if (detectedSource) {
        sessionStorage.setItem(SOURCE_KEY, detectedSource);
      }
    } catch (e) {
      console.error("Error parsing document.referrer:", e);
    }
  }
};

export const getLeadSource = () => {
  return sessionStorage.getItem(SOURCE_KEY) || "";
};
